var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text__container"},[_c('h2',[_vm._v("CREDITS")]),_vm._l((_vm.slice.items),function(cred){return _c('p',{key:cred.cred,attrs:{"field":_vm.slice.cred}},[_vm._v(" "+_vm._s(cred.cred)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }